export default "__VITE_ASSET__C_lU_3Fc__"